// @flow
export default {
  app: {
    railsEnv: 'production'
  },
}
